/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_ReviewInputs */

const en_cc_review = /** @type {(inputs: Cc_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This meeting link will be added to the Location field of the draft you opened. Existing location text is preserved. The meeting title is not copied.`)
};

const id_cc_review = /** @type {(inputs: Cc_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan meeting ini akan ditambahkan ke kolom Lokasi draf yang tadi Anda buka. Isi lokasi yang sudah ada dipertahankan. Judul meeting tidak disalin.`)
};

/**
* | output |
* | --- |
* | "This meeting link will be added to the Location field of the draft you opened. Existing location text is preserved. The meeting title is not copied." |
*
* @param {Cc_ReviewInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_review = /** @type {((inputs?: Cc_ReviewInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_ReviewInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_review(inputs)
	return en_cc_review(inputs)
});